<div class="modal__sidebar">
  <div class="modal__sidebar-top">
    @if (logoPosition === 'top') {
      <div class="modal__sidebar-logo">
        <app-icon [icon]="'logo-alt'" [width]="106" [height]="24" [color]="'primary'"></app-icon>
      </div>
    }
    <ng-content></ng-content>
  </div>
  <div class="modal__sidebar-footer">
    @if (socials) {
      <ul class="modal__sidebar-socials">
        <li>
          <a class="modal__sidebar-socials-link" [href]="'globals.contactData.facebook' | translate" target="_blank"><app-icon [icon]="'facebook'" [width]="24">Facebook</app-icon></a>
        </li>
        <li>
          <a class="modal__sidebar-socials-link" [href]="'globals.contactData.instagram' | translate" target="_blank"><app-icon [icon]="'instagram'" [width]="24">Instagram</app-icon></a>
        </li>
      </ul>
    }
    @if (logoPosition === 'bottom') {
      <app-icon [icon]="'logo-alt'" [width]="71" [height]="16" [color]="'primary'"></app-icon>
    }
  </div>
</div>
